import constants from 'common/constants'

import {ONBOARDING_COMPLETE} from './ActionTypes/ApiActionTypes'

/**
 * Tell the server the onboarding wizard was actually finished.
 *
 * This is the only genuine completion signal the product has — every other
 * onboarding substep is inferred server-side from whatever data a save call
 * persisted, so none of them can tell "finished the wizard" apart from
 * "opened a screen and went back".
 *
 * Fire-and-forget: the wizard navigates away regardless of the outcome.
 */
export const markOnboardingComplete = (onSuccess, onFailure) => {
  return {
    type: ONBOARDING_COMPLETE,
    payload: {
      apiUrl: constants.api_onboarding_complete,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: {},
      onSuccess,
      onFailure,
    },
  }
}
